export default class File {
    content = '';
    filename = '';
    options = {
        type: ''
    };

    constructor() {
    }
}